import { createReducer, on } from '@ngrx/store';
import { promotionId } from './promotion-action';
import { initialpromotionState } from './promotion-state';

const _promotionReducer = createReducer(
  initialpromotionState,
  on(promotionId, (state: any, action) => {
    return {
      ...state,
      promotion: action.data,
    };
  })
);

export function promotionReducer(state: any, action: any) {
  return _promotionReducer(state, action);
}
